import { useEffect } from 'react';
import { onlyText } from 'react-children-utilities';

import { useToast } from '@playbooks/contexts';
import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';

export const CodeElement = props => {
	const toast = useToast();

	// Hooks
	useEffect(() => {
		// logger.log('CodeElement: ', props);
	}, []);

	// Methods
	const onClick = () => {
		const code = onlyText(props.children.props.children);
		window.navigator.clipboard.writeText(code);
		toast.showSuccess(200, 'Copied to clipboard');
	};

	// Render
	return (
		<pre className='relative'>
			{props.filename && (
				<div className='border-b flex-between px-3 py-2'>
					<small className='block text-sm font-light text-foreground-body tracking-wide uppercase'>
						{props.filename}
					</small>
					{props.copy && (
						<Button variant='secondary' size='xs' onClick={onClick}>
							<Icon data-icon='inline-start' type='far' icon='clipboard' aria-hidden />
						</Button>
					)}
				</div>
			)}
			<div className='flex-between gap-2 p-3'>
				<div className='grow'>{props.children}</div>
				{!props.filename && props.copy && (
					<Button variant='secondary' size='icon' aria-label='Copy code' onClick={onClick}>
						<Icon data-icon='inline-start' type='far' icon='clipboard' aria-hidden />
					</Button>
				)}
			</div>
		</pre>
	);
};
// Docs
// https://github.com/fernandopasik/react-children-utilities/blob/main/docs/filter.md
